function useAuth() {
  const storKey = localStorage.getItem('accessToken');

  return storKey;
}
export { useAuth };
